<template>
  <div class="row full-width q-py-md justify-center">
    <div :class="['col-12 col-md-11', isMobile ? 'q-px-md' : undefined]">
      <div class="column full-width q-gutter-y-md">

        <!-- breadcrumbs -->
        <div class="row full-width justify-between items-center">
          <q-breadcrumbs active-color="grey-8" separator="/" separator-color="grey">
            <q-breadcrumbs-el class="text-primary-hover" label="صفحه اصلی" to="/"/>
            <q-breadcrumbs-el label="بلاگ"/>
          </q-breadcrumbs>
        </div>

        <!-- most viewed posts -->
        <blog-tile v-if="mostViewedBlog.length > 0" :posts="mostViewedBlog"/>
        <!-- most viewed end -->

        <!-- latest posts -->
        <div class="row full-width">
          <!-- title, more -->
          <div :class="['row full-width q-mb-lg justify-between items-center', isMobile? '' : 'q-px-sm']">

            <!-- title -->
            <div class="text-h6 text-bold text-grey-9">
              جدیدترین مطالب
            </div>

            <!-- more -->
            <router-link style="text-decoration: none" tag="div" to="/challenges">
              <q-btn class="border-radius q-px-md" color="primary" label="بیشتر" outline dense/>
            </router-link>

          </div>

          <div :class="['row full-width', isMobile ? 'q-mt-none q-gutter-y-md' : 'q-col-gutter-md']">
            <blog-post v-for="post of latestBlog" :post="post" :isGridShow="true" :showDescription="false"/>
          </div>
        </div>
        <!-- latest posts end -->

        <!-- most Liked posts -->
        <div class="row width-full bg-primary justify-center q-pl-md q-pr-sm q-py-md">
          <!-- title, more -->
          <div :class="['row col-11 items-stretch', isMobile? '' : 'q-px-sm']">

            <!-- title -->
            <div class="text-h6 text-bold text-white q-mb-lg">
              پر بازدیدترین مطالب
            </div>

            <!-- more -->
            <router-link style="text-decoration: none" tag="div" to="/challenges">
              <q-btn class="border-radius q-px-md" color="primary" label="بیشتر" outline dense/>
            </router-link>

          </div>

          <div :class="['row col-11 items-stretch', isMobile ? 'q-mt-none q-gutter-y-md' : 'q-col-gutter-md']">
            <blog-post v-for="post of mostLikedBlog" :post="post" :isGridShow="true" :showDescription="false"/>
          </div>
        </div>
        <!-- most Liked posts end -->

        <!-- newest posts -->
        <div class="row full-width">
          <!-- title, more -->
          <div :class="['row full-width q-mb-lg justify-between items-center', isMobile? '' : 'q-px-sm']">

            <!-- title -->
            <div class="text-h6 text-bold text-grey-9">
              جدیدترین مطالب
            </div>

            <!-- more -->
            <router-link style="text-decoration: none" tag="div" to="/challenges">
              <q-btn class="border-radius q-px-md" color="primary" label="بیشتر" outline dense/>
            </router-link>

          </div>

          <div :class="['row full-width', isMobile ? 'q-mt-none q-gutter-y-md' : 'q-col-gutter-md']">
            <blog-post v-for="post of mostLikedBlog" :post="post" :isGridShow="true" :showDescription="false"/>
          </div>
        </div>
        <!-- newest posts end -->

      </div>
    </div>
  </div>
</template>

<script>
import {useMeta} from "quasar";
import BlogPost from "components/blog/BlogPost";
import BlogPostSmall from "components/blog/BlogPostSmall";
import SPromotion from "components/shared/SPromotion";
import BlogTile from "components/blog/BlogTile.vue";
import axios from "axios";
import BlogSidebar from "components/blog/BlogSidebar.vue";

export default {
  name: "Blog",
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    await store.dispatch('loadBlog', {page: currentRoute.params.page ?? 1 , take: 8})
    await store.dispatch('getMeta', {pageUrl: 'https://www.hamiane.com/mag'})
    if (store.state.preFetch.blog == null) redirect('/404')
    let meta = {}
    meta.title = store.state.preFetch?.pageMeta?.metaTitle
    meta.description = store.state.preFetch?.pageMeta?.metaDescription
    meta.keywords = store.state.preFetch?.pageMeta?.metaKeywords
    meta.script = null
    return await store.dispatch('setMeta', meta)
  },
  data: () => ({
    baseUrl: process.env.API_URL,
    mostViewedBlog: [],
    mostLikedBlog: [],
    latestBlog:[],
    page: 1,
    totalPages: 1,
  }),
  components: {BlogSidebar, BlogTile, BlogPost, BlogPostSmall, SPromotion},
  computed: {
    isMobile() {
      return this.$q.screen.lt.md
    },
    posts() {
      return this.$store.state.preFetch.blog
    },
    pagination() {
      return {
        page: this.page,
        totalPages: this.$store.state.preFetch.blog.length
      }
    },
    // latestPosts() {
    //   return this.$store.state.preFetch.blog.slice(0, 8)
    // },
  },
  methods: {
    async changePage(evt) {
      console.log(evt)
      document.querySelector('body').scrollIntoView()
      this.pagination.page = evt
      this.page = evt
      await this.$store.dispatch('loadBlog', {page: evt, take: 8})
      await this.$router.replace(`/blog/page/${this.page}`).catch(err => {
      })
    },
    async loadMostViewedBlog() {
      try {
        const res = await this.$axios.get(`${process.env.API_URL}/Cms/Content/blog`, {
          params: {
            sortAsc: true,
            sortByView: true,
            page: 1,
            take: 4
          }
        });
        if (res.data?.success)
          this.mostViewedBlog = res.data?.result
      } catch (e) {
        console.log('BLOG Error:', e)
      }
    },
    async loadMostLikedBlog() {
      try {
        const res = await this.$axios.get(`${process.env.API_URL}/Cms/Content/blog`, {
          params: {
            sortAsc: true,
            sortByLike: true,
            page: 1,
            take: 4
          }
        });
        if (res.data?.success)
          this.mostLikedBlog = res.data?.result
      } catch (e) {
        console.log('BLOG Error:', e)
      }
    },
    async loadLatestBlog() {
      try {
        const res = await this.$axios.get(`${process.env.API_URL}/Cms/Content/blog`, {
          params: {
            sortAsc: true,
            page: 1,
            take: 4
          }
        });
        if (res.data?.success)
          this.latestBlog = res.data?.result
      } catch (e) {
        console.log('BLOG Error:', e)
      }
    },
  },
  async mounted() {
    useMeta(this.$store.state.meta)
    await this.loadMostLikedBlog();
    await this.loadMostViewedBlog();
    await this.loadLatestBlog();
  }
}
</script>
<style>
.sticky-sidebar {
  position: sticky;
  top: 60px;
}
</style>
